"use client";
import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { useId as t } from "react";
function s(n) {
  const e = t();
  return /* @__PURE__ */ r("svg", { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n, children: [
    /* @__PURE__ */ o("title", { children: "Tag Line Logo Icon" }),
    /* @__PURE__ */ o(
      "path",
      {
        d: "M32 4.01845V25.1411C32 26.3154 30.9971 27.2462 29.8223 27.1531L16.9277 26.1507C15.409 26.0361 13.8903 26.3727 12.565 27.1173L8.11641 29.6234C7.72241 29.8454 7.29259 29.3943 7.54332 29.0148L9.77121 25.5922L11.8415 22.4131C12.0636 22.0694 12.4934 21.9119 12.8874 22.0336C16.1397 23.079 19.8075 21.8761 21.7631 18.8831C24.0913 15.2886 23.0741 10.4913 19.4851 8.15706C15.8961 5.82282 11.0965 6.83958 8.76114 10.4269C6.81263 13.427 7.19946 17.272 9.4775 19.8139C9.74972 20.1218 9.77837 20.5729 9.5563 20.9237L6.92724 24.9621C6.76964 25.1984 6.49743 25.3344 6.21804 25.313L1.4184 24.9406C0.616073 24.8834 0 24.2175 0 23.4155V5.7369C0 4.93496 0.616073 4.26905 1.4184 4.21177L29.8294 2.00642C31.0043 1.91334 32 2.84417 32 4.01845ZM15.2586 9.35282C12.3286 9.35282 9.95747 11.7229 9.95747 14.6514C9.95747 16.0763 10.5234 17.3723 11.4403 18.3246C11.9991 18.9046 12.6868 19.3557 13.4605 19.6349C14.0264 19.8354 14.6282 19.95 15.2657 19.95C18.1957 19.95 20.5668 17.5799 20.5668 14.6514C20.5597 11.73 18.1885 9.35282 15.2586 9.35282Z",
        fill: `url(#${e})`
      }
    ),
    /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ r(
      "linearGradient",
      {
        id: e,
        x1: "1.5893",
        y1: "25.285",
        x2: "24.0784",
        y2: "10.1057",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ o("stop", { stopColor: "currentColor" }),
          /* @__PURE__ */ o("stop", { offset: "1", stopColor: "currentColor" })
        ]
      }
    ) })
  ] });
}
export {
  s as default
};
